import moment from 'moment';
import FlightTakeoffOutlinedIcon from '@material-ui/icons/FlightTakeoffOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import { displayDateFormatShort } from '../../../constants';
import { PLANNER_COLORS } from '../shared_components';
import { TAB_STATUS_QUERY } from './constants';

export const formatTrackerDate = (date) => (date && moment(date, moment.ISO_8601, true).isValid() ? moment(date).format(displayDateFormatShort) : date || '--');

/* Builds the `GET /plans` query string for the Tracker's tab/search/pagination state. */
export const buildTrackerListQuery = ({ tab, search, page, rowsPerPage }) => {
  const query = { status: TAB_STATUS_QUERY[tab], per_page: rowsPerPage, page: page + 1 };
  if (search) query.search = search;
  return query;
};

export const buildTrackerKpiCards = (kpis = {}) => ([
  { key: 'active_projects', icon: FlightTakeoffOutlinedIcon, label: 'Active Projects', value: kpis.active_projects?.count ?? 0, sub: kpis.active_projects?.sub_label || 'Launched & ongoing', color: PLANNER_COLORS.blue, tab: 'ongoing' },
  { key: 'closed_this_month', icon: CheckCircleOutlineIcon, label: 'Closed This Month', value: kpis.closed_this_month?.count ?? 0, sub: kpis.closed_this_month?.sub_label || 'Feedback and Closure', color: PLANNER_COLORS.green, tab: 'closed' },
  { key: 'due_this_week', icon: AccessTimeOutlinedIcon, label: 'Due This Week', value: kpis.due_this_week?.count ?? 0, sub: kpis.due_this_week?.sub_label || 'Planned end date', color: PLANNER_COLORS.orange, tab: 'ongoing' },
  { key: 'inactivity_alerts', icon: ReportProblemOutlinedIcon, label: 'Inactivity Alerts', value: kpis.inactivity_alerts?.count ?? 0, sub: kpis.inactivity_alerts?.sub_label, color: PLANNER_COLORS.red },
  { key: 'invoice_pending', icon: ReceiptOutlinedIcon, label: 'Invoice Pending', value: kpis.invoice_pending?.count ?? 0, sub: kpis.invoice_pending?.sub_label || 'Ready for invoice', color: PLANNER_COLORS.purple, tab: 'closed' },
]);

export const repDisplayName = (rep) => (
  rep?.name || rep?.user?.name || rep?.user?.email || (rep?.user_id ? `User #${rep.user_id}` : '--')
);

export const planDurationDays = (plan) => {
  const closedDate = plan?.client_acceptance_date || plan?.closed_at;
  if (!plan?.planned_start_date || !closedDate) return null;
  return moment(closedDate).diff(moment(plan.planned_start_date), 'days');
};
